// extracted by mini-css-extract-plugin
export default {"tableHead":"PackageBidderList_tableHead__qECud","tableBodyRow":"PackageBidderList_tableBodyRow__mePP9"};